<template>
    <div class="wrtTable">
        <Table :columns="columns1" :data="wrtData.thisweek" border></Table>
        <Table :columns="columns2" :data="wrtData.nextweek" border></Table>
        <Table :columns="columns3" :data="wrtData.else" border></Table>
    </div>
</template>

<script>
    import ajax from "@/lib/ajax"
    export default {
        data() {
            return {
                columns1: [{
                    renderHeader: (h) => {
                        return h('span', {
                            style: {
                                fontSize: '1.5em'
                            }
                        }, `${this.wrtData.years}年第${this.wrtData.weeks}周工作汇报`)
                    },
                    align: 'center',
                    children: [{
                            renderHeader: (h) => {
                                return h('span', {
                                    style: {
                                        fontSize: '1.2em'
                                    }
                                }, `姓名:${this.wrtData.name}`)
                            },
                            align: 'center',
                            children: [{
                                    title: '序号',
                                    align: 'center',
                                    width: 100,
                                    render: (h, params) => {
                                        return h('span', params.index + 1)
                                    }
                                },
                                {
                                    title: '本周工作中发现的问题',
                                    align: 'center',
                                    render: (h, params) => {
                                        return h('span', this.wrtData.thisweek[params.index]
                                            .problem)
                                    }
                                }
                            ]
                        },
                        {
                            renderHeader: (h) => {
                                return h('span', {
                                    style: {
                                        fontSize: '1.2em'
                                    }
                                }, `时间段:${this.wrtData.startToEnd}`)
                            },
                            align: 'center',
                            children: [{
                                    title: '解决方案',
                                    align: 'center',
                                    render: (h, params) => {
                                        return h('span', this.wrtData.thisweek[params.index]
                                            .solution)
                                    }
                                },
                                {
                                    title: '是否已解决',
                                    align: 'center',
                                    width: 150,
                                    render: (h, params) => {
                                        return h('span', this.wrtData.thisweek[params.index].ifDone)
                                    }
                                }
                            ]
                        }
                    ]
                }],
                columns2: [{
                        title: '序号',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', params.index + 1)
                        }
                    },
                    {
                        title: '下周工作重点',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.wrtData.nextweek[params.index].todo)
                        }
                    },
                    {
                        title: '预计完成时间',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('span', this.wrtData.nextweek[params.index].time)
                        }
                    }
                ],
                columns3: [{
                        title: '序号',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', params.index + 1)
                        }
                    },
                    {
                        title: '工作需要协调的事项',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.wrtData.else[params.index].consort)
                        }
                    },
                    {
                        title: '合理化建议',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.wrtData.else[params.index].suggest)
                        }
                    },
                ],
                years: 2019,
                weeks: 15,
                wrtData: {
                    years: '2019',
                    weeks: '15',
                    name: 'abc',
                    startToEnd: '2019/01/01-2019/01/07',
                    thisweek: [{
                            problem: 'abc',
                            solution: '解决方案abc',
                            ifDone: '是'
                        },
                        {
                            problem: 'abc',
                            solution: '解决方案abc',
                            ifDone: '是'
                        },
                        {
                            problem: 'abc',
                            solution: '解决方案abc',
                            ifDone: '是'
                        }
                    ],
                    nextweek: [{
                            todo: 'abc',
                            time: '2019-01-01'
                        },
                        {
                            todo: 'abc',
                            time: '2019-01-01'
                        },
                        {
                            todo: 'abc',
                            time: '2019-01-01'
                        }
                    ],
                    else: [{
                            consort: 'abc',
                            suggest: 'abc'
                        },
                        {
                            consort: 'abc',
                            suggest: 'abc'
                        },
                        {
                            consort: 'abc',
                            suggest: 'abc'
                        },
                    ]
                }
            }
        },
        methods:{
            async getData(){
                let rep = await ajax.get("http://192.168.160.101:8888/wrt/getAll");
                if(rep.data.success){
                    console.log(rep.data.result)
                }
            }
        },
        created(){
            this.getData();
        }
    }
</script>

<style lang="less">
    .wrt-table {
        .ivu-table:before {
            height: 0
        }
    }
</style>